const API_URL = process.env.REACT_APP_API_URL || '/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

export async function fetchHealth({ signal } = {}) {
  const res = await fetch(`${API_URL}/ready`, {
    signal,
    credentials: 'include',
    headers: { ...(API_KEY ? { 'x-api-key': API_KEY } : {}) },
  });
  try {
    return await res.json();
  } catch {
    return { status: 'down', components: {}, timestamp: null };
  }
}
